import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { selectCurrentBlade, startBladeNavigation } from '../../app/navigation/navigationSlice';
import { BLADE_NAME, LOAN_PURPOSE_ID } from '../../app/navigation/types';
import { useAppSelector } from '../../stories/hooks';

const DynamicHeader: React.FC = () => {
    const dispatch = useDispatch();
    const currentLoanPurposeID = useAppSelector((state) => state.loanPurpose.selectedLoanPurposeIds);
    const currentBladeName = useAppSelector(selectCurrentBlade);

    const [visitedBlades, setVisitedBlades] = useState<string[]>([]);
    const [step, setStep] = useState(1);
    const [lastPurposeID, setLastPurposeID] = useState<number | null>(null);
    const [updateBlades, setUpdateBlades] = useState(true);

    const stepCounts: { [key: number]: number } = useMemo(() => ({
        [LOAN_PURPOSE_ID.CAR]: 4,
        [LOAN_PURPOSE_ID.GREEN_PURCHASES]: 4,
        [LOAN_PURPOSE_ID.OTHERS]: 4,
        [LOAN_PURPOSE_ID.PERSONAL_GOODS]: 3,
        [LOAN_PURPOSE_ID.RENOVATIONS]: 3,
        [LOAN_PURPOSE_ID.DEBT_CONSOLIDATION]: 3,
        [LOAN_PURPOSE_ID.MEDICAL_AND_DENTAL]: 3,
        [LOAN_PURPOSE_ID.TRAVEL]: 3,
    }), []);

    useEffect(() => {
        if (currentLoanPurposeID && currentLoanPurposeID.length > 0) {
            if (lastPurposeID !== currentLoanPurposeID[0]) {
                setVisitedBlades([BLADE_NAME.LOAN_PURPOSE]);
                setStep(1);
                setLastPurposeID(currentLoanPurposeID[0]);
                setUpdateBlades(false);
                if (currentBladeName !== BLADE_NAME.LOAN_PURPOSE) {
                    dispatch(startBladeNavigation(BLADE_NAME.LOAN_PURPOSE));
                }
            }
        }
    }, [currentLoanPurposeID, dispatch]);

    useEffect(() => {
        if (currentBladeName && currentBladeName !== BLADE_NAME.GET_STARTED && updateBlades) {
            const currentIndex = visitedBlades.indexOf(currentBladeName);

            if (currentIndex === -1) {
                setVisitedBlades((prevVisitedBlades) => [...prevVisitedBlades, currentBladeName]);
                setStep((prevStep) => prevStep + 1);
            } else {
                setStep(currentIndex + 1);
            }
        }
        setUpdateBlades(true);
    }, [currentBladeName, visitedBlades]);

    const stepCount = currentLoanPurposeID.length > 0 ? stepCounts[currentLoanPurposeID[0]] || 5 : 1;

    return (
        <div>
            {currentLoanPurposeID?.length > 0 && <div role="status">Step {step} of {stepCount}</div>}
        </div>
    );
};

export default DynamicHeader;
